import type { ShopData } from '@/data/types';
import shopData from '@/data/shop.json';

export function useShopData() {
  const pageData = shopData as ShopData;
  return { pageData, loading: false, error: null };
}